export { default, default as Uniform } from './Uniform'